import { SpaceVertical } from '@looker/components';
import type { FC } from 'react';
import type { ICustomFilter } from '../../../../../helpers';
import type { Filter } from '../../../../../stores/filters';
import EngagementFilter from '../CustomFilterComponents/EngagementFilter';

export const MatchTypeFilter: FC<ICustomFilter> = ({ onChange }) => {
  const handleChildChange = (filter: Filter) => {
    if (onChange) {
      onChange(filter.expression);
    }
  };

  return (
    <SpaceVertical padding="0px 48px" gap="u2" width="100%" mb="u5" align="stretch">
      <EngagementFilter
        onChange={handleChildChange}
        filterId="smart_pixel_match_type_filter"
        filterLabel="Match Type"
        matchTypeFilter
      />
    </SpaceVertical>
  );
};
